import React, { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { X } from "lucide-react";
export default function Abschluss() {
  const [isImpressumOpen, setIsImpressumOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        setIsImpressumOpen(false);
        setIsPrivacyOpen(false);
      }
    };
    if (isImpressumOpen || isPrivacyOpen) {
      window.addEventListener("keydown", handleEsc);
      document.body.style.overflow = "hidden";
    }
    return () => {
      window.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "unset";
    };
  }, [isImpressumOpen, isPrivacyOpen]);
  const navigationLinks = [{
    label: "Startseite",
    to: "/HomePage"
  }, {
    label: "Angebote",
    to: "/AngebotePage"
  }, {
    label: "Retreats",
    to: "/RetreatsPage"
  }, {
    label: "Über Mich",
    to: "/AboutMePage"
  }, {
    label: "Kontakt",
    to: "/ContactPage"
  }];
  return <section data-section-id="13507" id="abschluss" className="bg-background text-foreground py-12 md:py-16">
      <div className="container mx-auto px-6 md:px-12 max-w-[1200px]">
        <Separator className="mb-12 bg-border h-[1px]" />
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          <div className="flex flex-col gap-4">
            <Link to="/">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/wandelherz_logo_footer.png" alt="Wandelherz" className="h-7 w-auto object-contain object-left self-start" />
            </Link>
            <p className="text-sm font-sans text-muted-foreground leading-relaxed">Ganzheitliche Heilung &amp; Transformation in Zürich, Südfrankreich, Provence</p>
          </div>

          <div className="flex flex-col gap-4">
            <h3 className="text-sm font-serif font-light text-foreground uppercase tracking-widest">
              Navigation
            </h3>
            <div className="flex flex-col gap-2">
              {navigationLinks.map((link, i) => <Link key={link.to} to={link.to} data-index={i} className="text-sm font-sans text-muted-foreground hover:text-primary transition-colors w-fit">
                  {link.label}
                </Link>)}
            </div>
          </div>

          <div className="flex flex-col gap-4">
            <h3 className="text-sm font-serif font-light text-foreground uppercase tracking-widest">
              Rechtliches
            </h3>
            <div className="flex flex-col gap-2">
              <button onClick={() => setIsImpressumOpen(true)} className="text-sm font-sans text-muted-foreground hover:text-primary transition-colors w-fit text-left cursor-pointer">
                Impressum
              </button>
              <button onClick={() => setIsPrivacyOpen(true)} className="text-sm font-sans text-muted-foreground hover:text-primary transition-colors w-fit text-left cursor-pointer">
                Datenschutz Erklärung
              </button>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-[10px] font-sans text-muted-foreground/60 tracking-wider">
            © {new Date().getFullYear()} Wandelherz. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>

      {}
      {isImpressumOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-8 bg-black/50 backdrop-blur-sm" onClick={() => setIsImpressumOpen(false)}>
          <div className="bg-background w-full max-w-3xl max-h-[90vh] overflow-y-auto rounded-lg shadow-2xl relative p-8 md:p-12" onClick={e => e.stopPropagation()}>
            <button onClick={() => setIsImpressumOpen(false)} className="absolute top-6 right-6 p-2 text-muted-foreground hover:text-foreground transition-colors" aria-label="Schliessen">
              <X className="w-6 h-6" />
            </button>

            <div className="space-y-8">
              <div>
                <h2 className="text-3xl font-serif font-light mb-6">Impressum</h2>
                <div className="space-y-4 text-sm font-sans text-muted-foreground leading-relaxed">
                  <section>
                    <h3 className="font-medium text-foreground mb-2">Angaben gemäss Art. 3</h3>
                    <p>Wandelherz<br />Zürich, Schweiz</p>
                  </section>

                  <section>
                    <h3 className="font-medium text-foreground mb-2">Tätigkeit</h3>
                    <p>Ganzheitliche Heilung, Transformation, Energiearbeit und Meditation.</p>
                  </section>

                  <section>
                    <h3 className="font-medium text-foreground mb-2">Haftungsausschluss</h3>
                    <p>Die Inhalte unserer Seiten wurden mit grösster Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.</p>
                  </section>

                  <section>
                    <h3 className="font-medium text-foreground mb-2">Urheberrechte</h3>
                    <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem schweizerischen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung ausserhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung.</p>
                  </section>

                  <section>
                    <h3 className="font-medium text-foreground mb-2">Datenschutz</h3>
                    <p>Informationen zum Umgang mit Ihren Daten finden Sie in unserer separaten Datenschutzerklärung.</p>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>}

      {}
      {isPrivacyOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-8 bg-black/50 backdrop-blur-sm" onClick={() => setIsPrivacyOpen(false)}>
          <div className="bg-background w-full max-w-3xl max-h-[90vh] overflow-y-auto rounded-lg shadow-2xl relative p-8 md:p-12" onClick={e => e.stopPropagation()}>
            <button onClick={() => setIsPrivacyOpen(false)} className="absolute top-6 right-6 p-2 text-muted-foreground hover:text-foreground transition-colors" aria-label="Schliessen">
              <X className="w-6 h-6" />
            </button>

            <div className="space-y-8">
              <div>
                <h2 className="text-3xl font-serif font-light mb-6">Datenschutzerklärung</h2>
                <div className="space-y-6 text-sm font-sans text-muted-foreground leading-relaxed">
                  <section>
                    <h3 className="font-medium text-foreground mb-2">1. Verantwortliche Stelle</h3>
                    <p>Verantwortlich für die Datenverarbeitung auf dieser Website ist Wandelherz, ansässig in Zürich, Schweiz. Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst und behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften.</p>
                  </section>

                  <section>
                    <h3 className="font-medium text-foreground mb-2">2. Rechtsgrundlagen</h3>
                    <p>Die Verarbeitung Ihrer Daten erfolgt auf Grundlage der geltenden Datenschutzbestimmungen, insbesondere zur Erfüllung unserer vertraglichen Pflichten oder aufgrund berechtigter Interessen zur Optimierung unseres Angebots.</p>
                  </section>

                  <section>
                    <h3 className="font-medium text-foreground mb-2">3. Cookies</h3>
                    <p>Wir setzen auf unserer Seite Cookies ein. Hierbei handelt es sich um kleine Dateien, die Ihr Browser automatisch erstellt und die auf Ihrem Endgerät gespeichert werden, um die Benutzerfreundlichkeit zu erhöhen.</p>
                  </section>

                  <section>
                    <h3 className="font-medium text-foreground mb-2">4. Analyse-Tools</h3>
                    <p>Zur bedarfsgerechten Gestaltung und fortlaufenden Optimierung unserer Webseite nutzen wir Analyse-Tools, die uns helfen, die Nutzung der Seite besser zu verstehen.</p>
                  </section>

                  <section>
                    <h3 className="font-medium text-foreground mb-2">5. Externe Links</h3>
                    <p>Unsere Website kann Links zu externen Webseiten Dritter enthalten, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.</p>
                  </section>

                  <section>
                    <h3 className="font-medium text-foreground mb-2">6. Sicherheit</h3>
                    <p>Wir setzen technische und organisatorische Sicherheitsmassnahmen ein, um Ihre durch uns verwalteten Daten gegen zufällige oder vorsätzliche Manipulationen, Verlust, Zerstörung oder gegen den Zugriff unberechtigter Personen zu schützen.</p>
                  </section>

                  <section>
                    <h3 className="font-medium text-foreground mb-2">7. Betroffenenrechte</h3>
                    <p>Sie haben das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung Ihrer personenbezogenen Daten sowie das Recht auf Datenübertragbarkeit.</p>
                  </section>

                  <section>
                    <h3 className="font-medium text-foreground mb-2">8. Speicherdauer</h3>
                    <p>Wir speichern personenbezogene Daten nur so lange, wie es für die Zwecke, für die sie erhoben wurden, erforderlich ist oder wie es die gesetzlichen Aufbewahrungsfristen vorsehen.</p>
                  </section>

                  <section>
                    <h3 className="font-medium text-foreground mb-2">9. Änderungen</h3>
                    <p>Wir behalten uns vor, diese Datenschutzerklärung gelegentlich anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen umzusetzen.</p>
                  </section>

                  <section>
                    <h3 className="font-medium text-foreground mb-2">10. Kontakt</h3>
                    <p>Bei Fragen zur Erhebung, Verarbeitung oder Nutzung Ihrer personenbezogenen Daten wenden Sie sich bitte direkt an uns über die im Impressum angegebenen Kontaktmöglichkeiten.</p>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </section>;
}